import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as Actions from '@/app/store/actions';
import './DisableConfirmDialog.css';
import { updateSubAdmin } from '@/app/services/subSchoolAdmin/SubSchoolAdmin';
import { CircularProgress } from '@material-ui/core';
import { bulkDeleteUsers } from '@shared/services/users';

const DisableOrDeleteConfirmDialog = ({ row, setRefresh, refresh, action }) => {
	const [isRequesting, setIsRequesting] = useState(false);
	const dispatch = useDispatch();

	const toggleActiveStatus = () => {
		setIsRequesting(true);
		const data = {
			acitvate_status: row.status ? 0 : 1,
		};
		updateSubAdmin(data, row?.id)
			.then(() => {
				dispatch(
					Actions.showMessage({
						message: `Sub Admin ${row.status ? 'Disabled' : 'Enabled'} Successfuly`,
						autoHideDuration: 1500,
						variant: 'success',
					})
				);
				setRefresh(!refresh);
				dispatch(Actions.closeDialog());
			})
			.catch(() => {
				dispatch(
					Actions.showMessage({
						message: 'Failed to Update Sub Admin Status, please refresh',
						autoHideDuration: 1500,
					})
				);
				dispatch(Actions.closeDialog());
			})
			.finally(() => {
				setIsRequesting(false);
			});
	};

	const handleDelete = () => {
		setIsRequesting(true);
		const payload = {
			user_id: [parseInt(row?.id)],
		};
		bulkDeleteUsers(payload)
			.then(() => {
				dispatch(
					Actions.showMessage({
						message: `Sub Admin Deleted Successfuly`,
						autoHideDuration: 1500,
						variant: 'success',
					})
				);
				setRefresh(!refresh);
				dispatch(Actions.closeDialog());
			})
			.catch(() => {
				dispatch(
					Actions.showMessage({
						message: 'Failed to Delete Sub Admin, please refresh',
						autoHideDuration: 1500,
					})
				);
			})
			.finally(() => {
				setIsRequesting(false);
			});
	};

	const handleConfirm = () => {
		if (action === 'activate') {
			toggleActiveStatus();
		} else {
			handleDelete();
		}
	};

	const title = action === 'activate' ? (row.status ? 'disable' : 'enable') : 'delete';

	return (
		<div className="popup">
			<div className="p-16">
				<div className="icon-span">
					<h2>!</h2>
				</div>
				<h1 className="">
					Are you sure you want to {title} <br />
					<span className="font-bold">{`${row.first_name} ${row.last_name}`}</span>?
				</h1>
				{isRequesting ? (
					<CircularProgress size={35} />
				) : (
					<>
						<button className="no-disable-btn" onClick={() => dispatch(Actions.closeDialog())} type="button">
							No
						</button>
						<button className="no-disable-btn" onClick={handleConfirm} type="button">
							Yes
						</button>
					</>
				)}
			</div>
		</div>
	);
};

export default DisableOrDeleteConfirmDialog;
